import "./assets/style/css/tailwind.css";
import "./assets/style/sass/main.scss";
import "./assets/style/sass/mixin.scss";
import VueApexCharts from "vue3-apexcharts";
export default {
  install(app) {
    app.use(VueApexCharts);
  },
};
